// 印尼语
import id from '../JsonLang/id.json'
import idSpec from '../JsonLangSpec/id.json'
export const lang = {
  ...id, ...idSpec
}